import getWorkflowStepTabQueryKey from './getWorkflowStepTabQueryKey.js';

const buildWorkflowStepSelectionQuery = ({ currentStepId, currentStepTab, nextStepId, nextStepTab }) => {
  const query = {
    stepId: nextStepId,
    stepTab: nextStepTab || null
  };

  if (currentStepId && currentStepTab) {
    query[getWorkflowStepTabQueryKey({ stepId: currentStepId })] = currentStepTab;
  }

  return query;
};

export default buildWorkflowStepSelectionQuery;
